import type {
  ClientConfiguration,
  ConfigurationSection,
} from "../types/clientConfig";

/** Effective section visible: `(mode !== 'hidden') || clientOptIn`. */
export function isSectionEffectivelyVisible(
  section: ConfigurationSection | undefined | null
): boolean {
  if (!section) {
    return false;
  }
  if (section.mode === "hidden") {
    return section.clientOptIn === true;
  }
  return true;
}

/** Whether menstrual cycle is on in a client configuration document only. */
export function isFemaleCycleSectionEnabledFromConfig(
  clientConfiguration: ClientConfiguration | null | undefined
): boolean {
  return isSectionEffectivelyVisible(
    clientConfiguration?.sections?.femaleCycleTracking
  );
}
